export default "__VITE_ASSET__T460$Uav__"